import { useLanguage } from "@/hooks/useLanguage";
import { Globe, Shield, Bot, TrendingUp, QrCode, LayoutDashboard, Zap } from "lucide-react";

export function TrustBar() {
  const { language } = useLanguage();

  const benefits = {
    fr: [
      { icon: Globe, label: "Multi-Plateformes", highlight: "(Google, FB, Yelp, Trustpilot, TripAdvisor)" },
      { icon: Shield, label: "Relation Client", highlight: "& Feedback Privé" },
      { icon: Bot, label: "Réponses IA", highlight: "Contextuelles" },
      { icon: TrendingUp, label: "SEO Local", highlight: "& Visibilité Maps" },
      { icon: QrCode, label: "QR Code Intelligent", highlight: "Dynamique" },
      { icon: LayoutDashboard, label: "Dashboard", highlight: "Centralisé" },
      { icon: Zap, label: "Gain de Temps", highlight: "Automatisé" },
    ],
    en: [
      { icon: Globe, label: "Multi-Platform", highlight: "(Google, FB, Yelp, Trustpilot, TripAdvisor)" },
      { icon: Shield, label: "Customer Relations", highlight: "& Private Feedback" },
      { icon: Bot, label: "AI Responses", highlight: "Contextual" },
      { icon: TrendingUp, label: "Local SEO", highlight: "& Maps Visibility" },
      { icon: QrCode, label: "Smart QR Code", highlight: "Dynamic" },
      { icon: LayoutDashboard, label: "Dashboard", highlight: "Centralized" },
      { icon: Zap, label: "Time Saving", highlight: "Automated" },
    ],
  };

  const items = benefits[language];
  // Triplicate for seamless infinite scroll
  const duplicatedItems = [...items, ...items, ...items];

  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-slate-50 via-white to-slate-50 py-6 border-y border-slate-100/80">
      <div className="flex items-center animate-scroll-left">
        {duplicatedItems.map((benefit, index) => {
          const IconComponent = benefit.icon;
          return (
            <div
              key={`${benefit.label}-${index}`}
              className="flex items-center"
            >
              <div className="flex items-center gap-2.5 px-6">
                <IconComponent 
                  size={18} 
                  className="text-primary flex-shrink-0" 
                  strokeWidth={2.5}
                />
                <span className="whitespace-nowrap">
                  <span className="text-sm font-semibold text-slate-800 tracking-wide">
                    {benefit.label}
                  </span>
                  {benefit.highlight && (
                    <span className="text-sm font-normal text-slate-500 ml-1">
                      {benefit.highlight}
                    </span>
                  )}
                </span>
              </div>
              {/* Subtle separator */}
              <span className="text-slate-300 text-xs mx-2">•</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
